// extracted by mini-css-extract-plugin
export default {"form":"AdminForm_form__wXA0q"};